<template>
    <a class="btn align-items-center justify-content-center"
        :class="classes"
        @click="clickEvent"
    >
        <span v-if="!(mobileNotText && isMobile)" :class="{'me-2': modelValue || icon}">{{ text }}</span>
        <span class="loader" v-if="modelValue"></span>
        <font-awesome-icon :icon="['fas', icon]" v-else-if="icon" />
    </a>
</template>

<script>
import screenMixin from 'mixins/screen'

export default {
    name: 'BaseButton',
    emits: ['update:modelValue'],
    data(){
        return {
            isMobile: false,
        };
    },
    props: {
        isFullWidth: {
            default: false,
            type: Boolean
        },
        modelValue: {
            default: false,
            type: Boolean
        },
        icon: {
            default: false,
        },
        text: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'primary'
        },
        mobileNotText: {
            default: false
        }
    },
    mixins: [
        screenMixin
    ],
    methods: {
        clickEvent(){
            this.$emit('clickEvent');
        }
    },
    computed: {
        classes() {
            const classes = [];
            classes.push('btn-' + this.color);
            if(this.color != 'light')
                classes.push('text-white');
            if(this.modelValue)
                classes.push('disabled');
            if(this.isFullWidth)
                classes.push('d-flex');
            else
                classes.push('d-inline-flex');
            return classes;
        }
    },
    beforeMount() {
        const self = this;
        window.addEventListener('resize', function(){
            self.isMobile = self.isBreakpoint('xs');
        });
        self.isMobile = self.isBreakpoint('xs');
    }
}
</script>

<style scoped>
    .loader {
        width: 10px;
        height: 10px;
        border: 2px solid var(--bs-white);
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }
    .btn-light .loader{
        border: 2px solid var(--bs-btn-color);
    }
    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    } 
</style>
